import Lookup from 'src/componentes/select2';

const TipoAcao = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoAcaoEnumLookup"
    {...rest}
  />
);

export default TipoAcao;
